import "assets/styles/teaser.scss";
import UserDetail from "components/ui/UserDetail/UserDetail";
import PropTypes from 'prop-types';
import Button from "components/ui/Button/Button";
import Label from "components/ui/Labels/Label";
import { useHistory } from "react-router-dom";

function ProfileTeaser({ name, city, photo, gender, age, distance, description, url, variant, created }) {
  const history = useHistory();

  let labelVariant;
  if (variant === 'dark') {
    labelVariant = 'light';
  } else {
    labelVariant = 'dark';
  }

  return (
    <div className={ `teaser ${ variant && 'teaser--' + variant }` }>
      <div className={ 'teaser__inner' }>
        <div className={ 'teaser__user' }>
          <UserDetail username={ name }
                      subtext={ city }
                      image={ photo }
                      url={ url }/>
        </div>

        <span>{ created }</span>

        <div className={ 'teaser__labels' }>
          {
            gender &&
            <Label variant={ labelVariant }>
              { gender }
            </Label>
          }
          {
            age &&
            <Label variant={ labelVariant }>
              { age } jaar
            </Label>
          }
          {
            distance &&
            <Label variant={ labelVariant }>
              { distance > 1 ? Math.round(distance) : '< 1' } km
            </Label>
          }
        </div>

        <div className={ 'teaser__intro' }>
          { description }
        </div>

        <div className={ 'teaser__button' }>
          <Button onClick={ () => history.push(url) } variant={ 'secondary' }>
            Bekijk profiel
          </Button>
        </div>
      </div>
    </div>
  );
}

ProfileTeaser.propTypes = {
  name: PropTypes.string.isRequired,
  city: PropTypes.string.isRequired,
  gender: PropTypes.string.isRequired,
  photo: PropTypes.string,
  age: PropTypes.string,
  distance: PropTypes.string,
  description: PropTypes.string,
  url: PropTypes.string.isRequired
}

export default ProfileTeaser;
